import { HTTP_REST_URLS } from "../config/urls";
import { useApiMiddleware } from "./useApiMiddleware";

export const useGetAllTagAndLanguage = () =>
    
    new Promise((resolve, reject) => {

        fetch(HTTP_REST_URLS.GET_TAG_AND_LANGUAGE, { method: "GET"})

            .then(res => res.json())

            .then(useApiMiddleware)

            .then(result => {

                const { tags_languages } = result;

                resolve({
                    tags: tags_languages.tags,
                    languages: tags_languages.languages
                });
            })
    });
